import { gql } from '@apollo/client'
import { CATEGORY_FRAGMENT } from 'apollo/fragments/Category'
import { SENTIMENT_GROUP_DISTRIBUTION_FRAGMENT } from 'apollo/fragments/MentionGroup'

export const GET_CATEGORIES = gql`
  query GetCategories(
    $filters: Filters!
    $withFeeds: Boolean = false
    $withCategories: Boolean = true
    $withAspects: Boolean = false
    $withTopFeeds: Boolean = false
    $withTopHashtags: Boolean = false
    $order: MentionsOrder
    $withCount: Boolean = false
  ) {
    groups(filters: $filters, aggregate: CATEGORY)
      @include(if: $withCategories) {
      count
      ... on CategoryGroup {
        category {
          id
          name
        }
      }

      previous @include(if: $withCount) {
        count
      }

      ...SentimentGroupDistribution

      byFeed: groups(aggregate: FEED) @include(if: $withFeeds) {
        count
        previous @skip(if: $withFeeds) {
          count
        }
        ... on FeedGroup {
          feed {
            id
            name
            avatarUrl
          }
        }

        ...SentimentGroupDistribution
      }

      ratingMean: countBy(aggregate: RATING_MEAN) {
        ... on Mean {
          mean
        }
      }
    }
    topAspects: groups(filters: $filters, aggregate: ASPECT, first: 3)
      @include(if: $withAspects) {
      count
      ... on AspectGroup {
        aspect
      }
    }
    topFeeds: groups(
      filters: $filters
      aggregate: FEED
      sort: EVOLUTION
      order: $order
    ) @include(if: $withTopFeeds) {
      count
      previous {
        count
      }
      ... on FeedGroup {
        feed {
          id
          name
          avatarUrl
        }
      }
    }
    topHashtags: groups(
      filters: $filters
      aggregate: HASHTAG
      sort: VOLUME
      order: $order
    ) @include(if: $withTopHashtags) {
      count
      ... on HashtagGroup {
        hashtag
      }
    }
  }
  ${SENTIMENT_GROUP_DISTRIBUTION_FRAGMENT}
`

export const GET_CATEGORIES_GROWTH = gql`
  query GetCategoriesGrowth(
    $filters: Filters!
    $categoryId: ID!
    $timezone: String
  ) {
    categoryGrowthByMentions(
      filters: $filters
      categoryId: $categoryId
      timezone: $timezone
    ) {
      category {
        id
        name
      }
      metrics {
        date
        count
        prevCount
      }
    }
  }
`

export const GET_MARKET_CATEGORIES = gql`
  query GetMarketCategories($productId: ID!, $filters: CategoriesFilterInput) {
    getMarketCategories(productId: $productId, filters: $filters) {
      total
      results {
        ...CategoryData
      }
    }
  }
  ${CATEGORY_FRAGMENT}
`

export const GET_CATEGORY = gql`
  query GetCategory($productId: ID!, $categoryId: ID!) {
    getCategory(productId: $productId, categoryId: $categoryId) {
      ...CategoryData
    }
  }
  ${CATEGORY_FRAGMENT}
`

export const GET_CUSTOM_CATEGORIES = gql`
  query GetCustomCategories($productId: ID!, $filters: CategoriesFilterInput) {
    getCustomCategories(productId: $productId, filters: $filters) {
      total
      results {
        ...CategoryData
      }
    }
  }
  ${CATEGORY_FRAGMENT}
`

export const GET_PRODUCT_CATEGORIES = gql`
  query GetProductCategories($productId: ID!) {
    getProduct(id: $productId) {
      categories {
        id
        name
        description
        isExtended
        isMarket
        keywords {
          words
          operator
        }
        riskLevel
        originalCategoryName
        source
      }
    }
  }
`
